import { getStaticAssetPath } from "../util";

const fallbackCoverImages = [
  getStaticAssetPath("/static/cover-images/gradient-01.jpg"),
  getStaticAssetPath("/static/cover-images/gradient-02.jpg"),
  getStaticAssetPath("/static/cover-images/gradient-03.jpg"),
  getStaticAssetPath("/static/cover-images/gradient-04.jpg"),
  getStaticAssetPath("/static/cover-images/gradient-05.jpg"),
  getStaticAssetPath("/static/cover-images/gradient-06.jpg"),
  getStaticAssetPath("/static/cover-images/gradient-07.jpg"),
  getStaticAssetPath("/static/cover-images/gradient-08.jpg"),
  getStaticAssetPath("/static/cover-images/gradient-09.jpg"),
];

function simpleHash(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return Math.abs(hash);
}

export function getFallbackCoverImage(seed?: string) {
  if (!seed) {
    return fallbackCoverImages[0];
  }
  const index = simpleHash(seed) % fallbackCoverImages.length;
  return fallbackCoverImages[index];
}
